import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { IcecontrolSettings, IcepanelsectionSettings, IcepanelSettings, SECTION_CONTROL_ALIGNMENT } from '../../../../icemedx-lib/src/components/models/icesettings';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { provider_index } from '../../../../icemedx-lib/src/models/domain/provider_index';
import { diagnosis } from '../../../../icemedx-lib/src/models/ehr/diagnosis';
import { encounter } from '../../../../icemedx-lib/src/models/ehr/encounter';
import { encounterindex } from '../../../../icemedx-lib/src/models/ehr/encounterindex';
import { encounterprogressnotes } from '../../../../icemedx-lib/src/models/ehr/encounterprogressnotes';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { encounterprogressnotesreference } from '../../../../icemedx-lib/src/models/ehr/subs/encounterprogressnotesreference';
import { observation } from '../../../../icemedx-lib/src/models/ehr/subs/observation';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { ScheduleService } from '../../../../icemedx-lib/src/services/schedule/schedule.service';
import { AppService } from '../app.service';

@Component({
  selector: 'listofproblems',
  templateUrl: './listofproblems.component.html',
  styleUrls: ['./listofproblems.component.scss'],
  providers: [AppService, IceNavService]
})
export class ListofproblemsComponent implements OnInit {

  @Input() currentPatient: string = "";
  @Input() currentSuperBill: string = "";
  @Input() problems: diagnosis[] = [];
  @Input() selectedICD: any[] = [];
  @Input() notes: encounterprogressnotes[] = [];
  @Input() encounters: encounter[] = [];
  @Input() assignedEncounters: encounter[] = [];
  @Output() problemUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() encounterUpdate: EventEmitter<any> = new EventEmitter<any>();
  loadSelected: boolean = false;

  searchICDCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "SearchICD", "ICD Search")
    .setControlName("SearchICD")
    .setMultipleSelection(true)
    .createFormControl("", [Validators.required]);

  diagContainer: any = {};
  encContainer: any = {};

  problemDialogRef: any = null;
  encounterDialogRef: any = null;
  observDialogRef: any = null;
  noteDialogRef: any = null;

  constructor(
    private appSvc: AppService,
    private medCodeSvc: MedicalcodesService,
    private domainSvc: DomainService,
    private proSvc: ProviderService,
    private ptSvc: PatientService,
    private accSvc: AccountingService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  getProblems(): diagnosis[] {
    if (this.loadSelected == false && this.selectedICD.length > 0) {
      this.loadSelected = true;
      this.searchICDCtrl.setOptions(this.selectedICD);
      this.searchICDCtrl.setMultipleSelection(true);
      this.searchICDCtrl.getFormControl().setValue(JSON.stringify(this.selectedICD));

    }
    return this.problems;
  }

  getICDSearchSelection(): any[] {
    let sel = this.searchICDCtrl.getFormControl().value;
    let ret: any[] = [];
    try {
      ret = JSON.parse(sel);
    }
    catch (e) {
      ret = [];
    }
    return ret;
  }

  getEncounters(): encounter[] {    
    return this.assignedEncounters.filter(enc => enc.BILLS.filter(b => b.superbill_charges_key == this.currentSuperBill).length > 0);
  }

  getObservationList(diag: diagnosis): IcecontrolSettings {
    if (this.diagContainer[diag.diagnosis_key] == null) {
      this.diagContainer[diag.diagnosis_key] = {
        record: diag,
      };
    }

    let opts = [];
    for (let iob = 0; iob < diag.OBSERVS.length; iob++) {
      let ob = diag.OBSERVS[iob];
      let desc = "Observation: " + Iceutility.getDateTextEx(ob.observation_date, null, false)
        + ", " + PatientService.getObservationType(ob.observation_type)
        + ", " + PatientService.getSeverityType(ob.severity_type)
        + ", " + ob.description;
      opts.push({ name: desc, value: ob.observation_key });
    }

    let editAction = {
      name: IceTypes.recordQuickActionEdit.name,
      value: IceTypes.recordQuickActionEdit.value,
      iconClass: { "fas": true, "fa-edit": true }
    }

    this.diagContainer[diag.diagnosis_key].observationCtrl
      = new IcecontrolSettings(diag.diagnosis_key, {}, null, null, "", "Observations")
        .setOptions(opts)
        .setActionItems([
          editAction
        ]);
    return this.diagContainer[diag.diagnosis_key].observationCtrl;
  }

  getNoteList(diag: diagnosis): IcecontrolSettings {
    if (this.diagContainer[diag.diagnosis_key] == null) {
      this.diagContainer[diag.diagnosis_key] = {
        record: diag,
      };
    }

    let opts = [];
    for (let inte = 0; inte < diag.NOTES.length; inte++) {
      let nte = diag.NOTES[inte];
      let fndNote = this.notes.filter(n => n.encounter_progress_notes_key == nte.encounter_progress_notes_key);
      if (fndNote.length > 0) {
        let desc = AccountingService.getSourceType(Iceutility.toLong(fndNote[0].src_type)) + " " + Iceutility.getDateTextEx(fndNote[0].note_date, null, true) + ", " + fndNote[0].plain_text;
        let icons = [];
        if (diag.diagnosis_key != fndNote[0].src_key)
          icons.push({ "fas": true, "fa-solid": true, "fa-link": true });

        switch (Iceutility.toLong(fndNote[0].note_status_type)) {
          case IceTypes.notestatus.statusComplete: {
            icons.push({ "fas": true, "fa-solid": true, "fa-check": true });
            break;
          }
          case IceTypes.notestatus.statusCompleteRequired:
          case IceTypes.notestatus.statusPatientCompleteRequired: {
            icons.push({ "fas": true, "fa-regular": true, "fa-circle": true });
            break;
          }
          case IceTypes.notestatus.statusInitialDraft: {
            icons.push({ "fas": true, "fa-solid": true, "fa-circle-notch": true });
            break;
          }
          case IceTypes.notestatus.statusInProgress: {
            icons.push({ "fas": true, "fa-regular": true, "fa-spinner": true });
            break;
          }
        }

        opts.push({
          name: desc,
          value: nte.encounter_progress_notes_key,
          icons: icons
        });
      }
    }

    let editAction = {
      name: IceTypes.recordQuickActionEdit.name,
      value: IceTypes.recordQuickActionEdit.value,
      iconClass: { "fas": true, "fa-edit": true }
    }

    this.diagContainer[diag.diagnosis_key].noteListCtrl =
      new IcecontrolSettings(diag.diagnosis_key, {}, null, null, "", "Notes")
        .setOptions(opts)
        .setActionItems([
          editAction
        ]);
    return this.diagContainer[diag.diagnosis_key].noteListCtrl;
  }

  getEncounterNoteList(enc: encounter): IcecontrolSettings {
    if (this.encContainer[enc.encounter_key] == null) {
      this.encContainer[enc.encounter_key] = {
        record: enc,
      };
    }

    let opts = [];
    for (let inte = 0; inte < enc.NOTES.length; inte++) {
      let nte = enc.NOTES[inte];
      let fndNote = this.notes.filter(n => n.encounter_progress_notes_key == nte.encounter_progress_notes_key);
      if (fndNote.length > 0) {
        let desc = AccountingService.getSourceType(Iceutility.toLong(fndNote[0].src_type)) + " " + Iceutility.getDateTextEx(fndNote[0].note_date, null, true) + ", " + fndNote[0].plain_text;
        let icons = [];
        if (enc.encounter_key != fndNote[0].src_key)
          icons.push({ "fas": true, "fa-solid": true, "fa-link": true });

        switch (Iceutility.toLong(fndNote[0].note_status_type)) {
          case IceTypes.notestatus.statusComplete: {
            icons.push({ "fas": true, "fa-solid": true, "fa-check": true });
            break;
          }
          case IceTypes.notestatus.statusCompleteRequired:
          case IceTypes.notestatus.statusPatientCompleteRequired: {
            icons.push({ "fas": true, "fa-regular": true, "fa-circle": true });
            break;
          }
          case IceTypes.notestatus.statusInitialDraft: {
            icons.push({ "fas": true, "fa-solid": true, "fa-circle-notch": true });
            break;
          }
          case IceTypes.notestatus.statusInProgress: {
            icons.push({ "fas": true, "fa-regular": true, "fa-spinner": true });
            break;
          }
        }

        opts.push({
          name: desc,
          value: nte.encounter_progress_notes_key,
          icons: icons
        });
      }
    }

    let editAction = {
      name: IceTypes.recordQuickActionEdit.name,
      value: IceTypes.recordQuickActionEdit.value,
      iconClass: { "fas": true, "fa-edit": true }
    }

    this.encContainer[enc.encounter_key].noteListCtrl =
      new IcecontrolSettings(enc.encounter_key, {}, null, null, "", "Notes")
        .setOptions(opts)
        .setActionItems([
          editAction
        ]);
    return this.encContainer[enc.encounter_key].noteListCtrl;
  }

  getModified(user: string, modified: any): string {
    return user + " (" + Iceutility.getDateTextEx(modified, null, true) + ")";
  }

  getDate(dt: any, includeTime: boolean): string {
    return Iceutility.getDateTextEx(dt, null, includeTime);
  }

  getProblemState(typ: any): string {
    return PatientService.getProblemState(Iceutility.toLong(typ));
  }

  getProblemStatus(typ: any): string {
    return PatientService.getProblemStatus(Iceutility.toLong(typ));
  }

  getEncounterStatus(typ: any): string {
    return ScheduleService.getApptStat(Iceutility.toLong(typ));
  }

  getEncounterAbstract(enc: encounter): string {
    return ScheduleService.getAppointmentType(Iceutility.toLong(enc.appointment_type)) /*Add remaining*/;
  }

  getEncounterConsent(enc: encounter): string {
    return enc.signature.length > 0 ? "Yes" : "No";
  }

  getEncounterSigned(enc: encounter): string {
    return enc.doctor_signature.length > 0 ? "Yes" : "No";
  }

  getProblemEditClass(): any {
    return { "fas": true, "fa-edit": true, "fa-2x": true };
  }

  getICDEditClass(result: any): any {
    let fndDx = this.problems.filter(dx => dx.icd_code == result.value);
    if (fndDx.length > 0)
      return { "fas": true, "fa-edit": true, "fa-2x": true };

    return { "fas": true, "fa-plus-circle": true, "fa-2x": true };
  }

  getEncounterEditClass(): any {
    return this.getProblemEditClass();
  }

  getEncounterUnassignClass(): any {
    return { "fas": true, "fa-times": true, "fa-2x": true };
  }

  insertUpdateProblem(diag: diagnosis): void {
    this.ptSvc.insertUpdateDiagnsosis(this.currentPatient, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), diag, IceTypes.dtformat.dtfUTC_YYYYMMDD_T_HHMMSS_Z).subscribe(
      data => {
        if (data == null || data.length == 0) return;

        if (this.problems == null || this.problems.length == 0)
          this.problems = [];

        this.problems.push(data[0]);
        this.problemUpdate.emit(data);
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully saved: " + diag.title);
      },
      error => {
        console.log(JSON.stringify(error))
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Saving: " + diag.title);
      }
    )
  }

  insertUpdateEncounter(enc: encounter): void {
    this.proSvc.insertUpdateEncounter(enc, this.appSvc.getCurrentAccount(), this.currentPatient, this.appSvc.getCurrentAccountType()).subscribe(
      data => {
        if (data == null || data.length == 0) return;

        if (this.encounters == null || this.encounters.length == 0)
          this.encounters = [];

        if (this.assignedEncounters == null || this.assignedEncounters.length == 0)
          this.assignedEncounters = [];

        let uptedEncIdx: encounterindex = data[0];
        if (enc.BILLS.filter(b => b.superbill_charges_key == this.currentSuperBill).length == 0) {
          this.accSvc.assignBilltoEncounter(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
            uptedEncIdx.encounter_key, this.currentSuperBill).subscribe(
              newEnc => {
                if (newEnc != null && newEnc.length > 0) {
                  this.assignedEncounters.push(newEnc[0]);
                  this.encounters.push(newEnc[0]);
                }

                this.encounterUpdate.emit(newEnc[0]);
              },
              err => {
                console.log(err);
              }
            );
        }
        else {
          this.encounterUpdate.emit(enc);
        }

        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully saved encounter.");
      },
      error => {
        console.log(JSON.stringify(error))
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Saving.");
      }
    )
  }

  doProblemPopup(diag: diagnosis) {
    let title = "", code = "", onSet: any = NaN, resDate: any = NaN;
    let state: IceTypes.problemstate;
    let status: IceTypes.problemstatus;

    if (diag != null) {
      title = diag.title;
      code = diag.icd_code;
      onSet = Iceutility.GetLocalDate(diag.onset_of_illness_date);
      resDate = Iceutility.GetLocalDate(diag.resolution_date);
      state = diag.state_type;
      status = diag.status_type;
    }

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ProblemSection1", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceinput", { width: "350px" }, null, null, "ICDCode", "ICD Code")
          .setControlName("icd_code")
          .createFormControl(code, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection2", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icetextarea", { width: "350px", height: "75px" }, null, null, "Title", "Title")
          .setControlName("title")
          .createFormControl(title, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection3", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icedatepicker", { placeholder: "Onset of Problem", width: "175px" }, null, null, "OnsetofProblem")
          .setControlName("onset_of_illness_date")
          .createFormControl(onSet, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection4", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icedatepicker", { placeholder: "Resolution Date", width: "175px" }, null, null, "ResolutionDate")
          .setControlName("resolution_date")
          .createFormControl(resDate, [])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection5", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "State", "StateofProblem")
          .setControlName("state_type")
          .createFormControl(state, [Validators.required])
          .setOptions(PatientService.getProblemStates())], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection6", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "Status", "StatusofProblem")
          .setControlName("status_type")
          .createFormControl(status, [Validators.required])
          .setOptions(PatientService.getProblemStatuses())], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      ];
    
    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.problemDialogRef = this.dialog.open(IcepanelDialog, {
      height: '550px',
      width: '550px',
      data: {
        record: diag,
        panel: new IcepanelSettings("", "", "Problem", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.problemDialogRef;
    this.problemDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;
      
      let diag: diagnosis = <diagnosis>ref.componentInstance.data.record;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && diag != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "icd_code": {
                  diag.icd_code = ctrl.getFormControl().value;
                  break;
                }
                case "title": {
                  diag.title = ctrl.getFormControl().value;
                  break;
                }
                case "onset_of_illness_date": {
                  diag.onset_of_illness_date = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "resolution_date": {
                  diag.resolution_date = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "state_type": {
                  diag.state_type = ctrl.getFormControl().value;
                  break;
                }
                case "status_type": {
                  diag.status_type = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          this.insertUpdateProblem(diag);
        }
      }
    });
  }

  doEncounterPopup(enc: encounter) {
    if (enc == null) return;
    let startTime: Date = Iceutility.GetLocalDate(enc.time_slot_start),
      endTime: Date = Iceutility.GetLocalDate(enc.time_slot_end),
      modTime: any = NaN;
    let type: IceTypes.appt_type = Iceutility.toLong(enc.appointment_type);
    let status: IceTypes.appt_status = Iceutility.toLong(enc.appointment_status);

    let ctrlStart: IcecontrolSettings = null,
      ctrlEnd: IcecontrolSettings = null,
      ctrlApptType: IcecontrolSettings = null,
      ctrlApptStatus: IcecontrolSettings = null;

    let sections: IcepanelsectionSettings[] = [];

    if (enc.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
      let opts = [{ name: "Create New Encounter", value: "", time: 0 }];
      for (let ienc = 0; ienc < this.encounters.length; ienc++) {
        let thisenc = this.encounters[ienc];

        if (this.encContainer[thisenc.encounter_key] != null)
          continue; // this enc is already loaded

        let dates = Iceutility.getDateTextEx(thisenc.time_slot_start, null, true);
        if (thisenc.time_slot_end.length > 0)
          dates += " - " + Iceutility.getDateTextEx(thisenc.time_slot_end, null, true);

        let startDt = Iceutility.GetLocalDate(thisenc.time_slot_start);
        let desc = ScheduleService.getAppointmentType(Iceutility.toLong(thisenc.appointment_type)) + ", " + ScheduleService.getApptStat(Iceutility.toLong(thisenc.appointment_status)) + " on " + dates;
        opts.push({
          name: desc,
          value: thisenc.encounter_key,
          time: startDt.getTime()
        });
      }

      opts.sort((a, b) => {
        let aV: number = a["time"];
        let bV: number = b["time"];
        return bV - aV;
      });

      let encAssignments = new IcecontrolSettings("iceselect", { width: "470px" }, null, null, "AssignEncounter", "Encounter to Assign")
        .setControlName("encounter_key")
        .createFormControl("", [])
        .setOptions(opts);

      sections.push(
        new IcepanelsectionSettings("NoteSection0", { class: ["yalla"], styles: {} }, [],
          [encAssignments], null));

      encAssignments.createChangeControlEvent().subscribe(
        event => {
          let fndEnc = this.encounters.filter(n => n.encounter_key == event.value);
          if (fndEnc.length > 0) {
            ctrlStart.getFormControl().setValue(Iceutility.GetLocalDate(fndEnc[0].time_slot_start));
            ctrlEnd.getFormControl().setValue(Iceutility.GetLocalDate(fndEnc[0].time_slot_end));
            ctrlApptType.getFormControl().setValue(Iceutility.toLong(fndEnc[0].appointment_type));
            ctrlApptStatus.getFormControl().setValue(Iceutility.toLong(fndEnc[0].appointment_status));
          }
          else {
            ctrlStart.getFormControl().setValue(Iceutility.GetLocalDate());
            ctrlEnd.getFormControl().setValue(Iceutility.GetLocalDate());
            ctrlApptType.getFormControl().setValue(IceTypes.appt_type.appttypeInitial);
            ctrlApptStatus.getFormControl().setValue(IceTypes.appt_status.apptstatNone);
          }
        },
        error => {
        }
      );

    }

    sections.push(
      new IcepanelsectionSettings("EncounterSectionStart", { class: ["yalla"], styles: {} }, [],
        [ctrlStart = new IcecontrolSettings("icedatepicker", { placeholder: "Start Time", width: "175px" }, null, null, "StartTime")
          .setControlName("time_slot_start")
          .createFormControl(startTime, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical));

    sections.push(
      new IcepanelsectionSettings("EncounterSectionEnd", { class: ["yalla"], styles: {} }, [],
        [ctrlEnd = new IcecontrolSettings("icedatepicker", { placeholder: "End Time", width: "175px" }, null, null, "EndTime")
          .setControlName("time_slot_end")
          .createFormControl(endTime, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical));

    sections.push(
      new IcepanelsectionSettings("EncounterSectionType", { class: ["yalla"], styles: {} }, [],
        [ctrlApptType = new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "Type", "Type of Encounter")
          .setControlName("appointment_type")
          .createFormControl(type, [Validators.required])
          .setOptions(ScheduleService.getAppointmentTypes())], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical));

    sections.push(
      new IcepanelsectionSettings("EncounterSectionStatus", { class: ["yalla"], styles: {} }, [],
        [ctrlApptStatus = new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "Status", "Status of Encounter")
          .setControlName("appointment_status")
          .createFormControl(status, [Validators.required])
          .setOptions(ScheduleService.getApptStatuses())], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical));

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.encounterDialogRef = this.dialog.open(IcepanelDialog, {
      height: '550px',
      width: '550px',
      data: {
        record: enc,
        parentrecord: this.encounters,
        panel: new IcepanelSettings("", "", enc.offline_record_status == IceTypes.offlineRecStatus.offlineInsert ? "Assign Encounter" : "Edit Encounter", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.encounterDialogRef;
    this.encounterDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;
      let enc: encounter = <encounter>ref.componentInstance.data.record;
      let allEncs: encounter[] = <encounter[]>ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && enc != null && allEncs != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "encounter_key": {
                  let fndEnc = allEncs.filter(n => n.encounter_key == ctrl.getFormControl().value);
                  if (fndEnc.length > 0) {
                    enc = fndEnc[0];
                  }
                  break;
                }
                case "time_slot_start": {
                  // Once the time is added here then we can remove setting the hours
                  let dt: Date = ctrl.getFormControl().value;
                  try {
                    let startTime: Date = Iceutility.GetLocalDate(enc.time_slot_start);
                    if (isNaN(startTime.getTime()))
                      startTime = Iceutility.GetLocalDate();

                    dt.setHours(startTime.getHours(), startTime.getMinutes(), startTime.getSeconds(), startTime.getMilliseconds());
                  }
                  catch (eDt) {
                    console.log(eDt);
                  }
                  enc.time_slot_start = Iceutility.GetDateText(dt);
                  break;
                }
                case "time_slot_end": {
                  // Once the time is added here then we can remove setting the hours
                  let dt: Date = ctrl.getFormControl().value;
                  try {
                    let endTime: Date = Iceutility.GetLocalDate(enc.time_slot_end);
                    if (isNaN(endTime.getTime()))
                      endTime = Iceutility.GetLocalDate();

                    dt.setHours(endTime.getHours(), endTime.getMinutes(), endTime.getSeconds(), endTime.getMilliseconds());
                  }
                  catch (eDt) {
                    console.log(eDt);
                  }
                  enc.time_slot_end = Iceutility.GetDateText(dt);
                  break;
                }
                case "appointment_type": {
                  enc.appointment_type = ctrl.getFormControl().value;
                  break;
                }
                case "appointment_status": {
                  enc.appointment_status = ctrl.getFormControl().value;
                  break;
                }
                case "xxxx": {
                  //diag.state_type = ctrl.getFormControl().value;
                  break;
                }
                case "yyyy": {
                  //diag.status_type = ctrl.getFormControl().value;
                  break;
                }
              }              
            }
          }

          this.insertUpdateEncounter(enc);
        }
      }
    });
  }

  doObservationPopup(observ: observation, diag: diagnosis) {
    let descText = "",
      obDate = Iceutility.GetLocalDate(),
      obType = IceTypes.observationtype.observTypeSymptom,
      obServTy = IceTypes.severitytype.servTypeMild;

    if (observ != null) {
      descText = observ.description;
      obDate = Iceutility.GetLocalDate(observ.observation_date);
      obType = Iceutility.toLong(observ.observation_type);
      obServTy = Iceutility.toLong(observ.severity_type);
    }

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ObDateSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icedatepicker", { placeholder: "Date of Observation", width: "175px" }, null, null, "Date of Observation")
          .setControlName("observation_date")
          .createFormControl(obDate, [Validators.required])], null),
      new IcepanelsectionSettings("ObTypeSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "State", "State of Problem")
          .setControlName("observation_type")
          .createFormControl(obType, [Validators.required])
          .setOptions(PatientService.getObservations())], null),
      new IcepanelsectionSettings("ObTypeSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "State", "State of Problem")
          .setControlName("severity_type")
          .createFormControl(obServTy, [Validators.required])
          .setOptions(PatientService.getSeverities())], null),
      new IcepanelsectionSettings("ObDescSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icetextarea", { width: "300px", height: "100px" }, null, null, "Description", "Description")
            .setControlName("description")
            .createFormControl(descText, [Validators.required])
        ], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.observDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: observ,
        parentrecord: diag,
        panel: new IcepanelSettings("", "", "Observation", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.observDialogRef;
    this.observDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let observ: observation = <observation>ref.componentInstance.data.record;
      let diag: diagnosis = <diagnosis>ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && diag != null && observ != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "description": {
                  observ.description = ctrl.getFormControl().value;
                  break;
                }
                case "observation_date": {
                  // store standard date 
                  observ.observation_date = Iceutility.GetDateText(ctrl.getFormControl().value);
                  break;
                }
                case "observation_type": {
                  observ.observation_type = ctrl.getFormControl().value;
                  break;
                }
                case "severity_type": {
                  observ.severity_type = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          if (observ.observation_key == null || observ.observation_key.length == 0)
            diag.OBSERVS.push(observ);

          this.insertUpdateProblem(diag);
        }
      }
    });

  }

  doNotePopup(noteref: encounterprogressnotesreference, srcType: IceTypes.SourceType, srcKey: string, prec: IceEntity) {
    if (noteref == null) {
      return;
    }

    let note: encounterprogressnotes = null;

    let opts = [{ name: "Create New Note", value: "", srckey: "", srctype: IceTypes.SourceType.srcUndefined }];
    for (let inte = 0; inte < this.notes.length; inte++) {
      let nte = this.notes[inte];
      if (nte.encounter_progress_notes_key == noteref.encounter_progress_notes_key) {
        note = nte;
      }

      if (srcKey != nte.src_key) { // don't add notes that are apart of diagnosis or encounter
        let desc = AccountingService.getSourceType(Iceutility.toLong(nte.src_type)) + " Notes on " + Iceutility.getDateTextEx(nte.note_date, null, true);
        opts.push({ name: desc, value: nte.encounter_progress_notes_key, srckey: nte.src_key, srctype: nte.src_type });
      }
    }

    if (note == null) {
      note = new encounterprogressnotes();
      note.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
      note.src_key = "";
      note.src_type = srcType;
      note.trans_account = this.currentPatient;
      note.name = "0";
      note.note_date = NaN;
      note.note_status_type = IceTypes.NoteStatus.statusInitialDraft;
      //  note.encounter_progress_notes_type: number = 0;
      //  note.cfield_data: string = "";

      noteref.offline_record_status = note.offline_record_status;
    }

    let dateCtrl: IcecontrolSettings = null;
    let noteCtrl: IcecontrolSettings = null;
    let authCtrl: IcecontrolSettings = null;
    let typeCtrl: IcecontrolSettings = null;
    let statCtrl: IcecontrolSettings = null;

    let sections: IcepanelsectionSettings[] = [];

    if (srcType == IceTypes.SourceType.srcDiagnosis) {
      let noteLinks = new IcecontrolSettings("iceselect", { width: "325px" }, null, null, "LinkEncounterNote", "Link to Encounter Note")
        .setControlName("encounter_progress_notes_key")
        .createFormControl(note.encounter_progress_notes_key, [])
        .setOptions(opts);

      if (note.encounter_progress_notes_key == "" || srcKey != note.src_key) {
        sections.push(
          new IcepanelsectionSettings("NoteSection0", { class: ["yalla"], styles: {} }, [],
            [noteLinks], null),
        );

        if (note.encounter_progress_notes_key.length > 0 && srcKey != note.src_key) {
          noteLinks.setDisabled(true);
        }
      }

      noteLinks.createChangeControlEvent().subscribe(
        event => {
          let fndNote = this.notes.filter(n => n.encounter_progress_notes_key == event.value);
          if (fndNote.length > 0) {
            dateCtrl.getFormControl().setValue(Iceutility.GetLocalDate(fndNote[0].note_date));
            noteCtrl.getFormControl().setValue(fndNote[0].plain_text);
            statCtrl.getFormControl().setValue(Iceutility.toLong(fndNote[0].note_status_type));
            let fndLink = authCtrl.getOptions().filter(o => o.value == fndNote[0].provider_trans_account);
            if (fndLink.length > 0) {
              let authDesc = JSON.stringify([{ name: fndLink[0].name, value: fndLink[0].value }]);
              authCtrl.getFormControl().setValue(authDesc);
            }
            //typeCtrl
            note = fndNote[0];
            noteref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert
            noteref.encounter_progress_notes_key = note.encounter_progress_notes_key;

            dateCtrl.setReadonly(true);
            noteCtrl.setReadonly(true);
            authCtrl.setReadonly(true);
            //typeCtrl.setDisabled(true);
          }
          else {
            dateCtrl.getFormControl().setValue(Iceutility.GetLocalDate());
            noteCtrl.getFormControl().setValue("");
            statCtrl.getFormControl().setValue(IceTypes.NoteStatus.statusInitialDraft);
            authCtrl.getFormControl().setValue("");
            //typeCtrl

            dateCtrl.setReadonly(false);
            noteCtrl.setReadonly(false);
            authCtrl.setReadonly(false);
            //typeCtrl.setDisabled(false);
          }
        },
        error => {
        }
      );
    }

    sections.push(
      new IcepanelsectionSettings("NoteSection1", { class: ["yalla"], styles: {} }, [],
        [
          dateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "Date of Note", width: "175px" }, null, null, "Date of Note")
            .setControlName("note_date")
            .createFormControl(Iceutility.GetLocalDate(note.note_date), [Validators.required])], null),
      new IcepanelsectionSettings("NoteSection3", { class: ["yalla"], styles: {} }, [],
        [
          authCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "400px" }, null, null, "provider_trans_account", "Author of Note")
            .setControlName("provider_trans_account")
            .createFormControl("", [Validators.required])
        ], null),
      new IcepanelsectionSettings("NoteSection4", { class: ["yalla"], styles: {} }, [],
        [
          statCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "400px" }, null, null, "note_status_type", "Status")
            .setControlName("note_status_type")
            .createFormControl(Iceutility.toLong(note.note_status_type), [Validators.required])
            .setOptions(DomainService.getNoteStatuses())
        ], null),
      new IcepanelsectionSettings("NoteSection2", { class: ["yalla"], styles: {} }, [],
        [
          noteCtrl = new IcecontrolSettings("icetextarea", { width: "400px", height: "400px" }, null, null, "Description", "Description")
            .setControlName("plain_text")
            .createFormControl(note.plain_text, [Validators.required]),
        ], null),
    );

    this.proSvc.getPracticeProviders(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "").subscribe(
      data => {
        if (data != null && data.length > 0) {
          let opts = [];
          for (let ipro = 0; ipro < data.length; ipro++) {
            let proIdx: provider_index = data[ipro];
            opts.push({ name: proIdx.getdisplayname(false), value: proIdx.trans_account });
          }
          authCtrl.setOptions(opts);
        }
      },
      error => {
        console.log(JSON.stringify(error))
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading practice providers.");
      });

    if (authCtrl != null && note.provider_trans_account.length > 0) {
      this.domainSvc.getProvider(note.provider_trans_account).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let pro: provider = <provider>data[0];
            let authDesc = JSON.stringify([{ name: pro.getdisplayname(false), value: pro.trans_account }]);
            authCtrl.getFormControl().setValue(authDesc);
          }
        },
        error => {
          console.log(JSON.stringify(error))
          this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading provider.");
        });
    }

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    if (srcType == IceTypes.SourceType.srcDiagnosis) {
      if (note.encounter_progress_notes_key.length > 0 && srcKey != note.src_key) {
        headerControls.push(new IcecontrolSettings("icebutton", { class: "fas fa-solid fa-trash", width: "50px" }, null, null, "RemoveLink"));
      }
    }

    this.noteDialogRef = this.dialog.open(IcepanelDialog, {
      height: '500px',
      width: '500px',
      data: {
        record: noteref,
        parentrecord: prec,
        panel: new IcepanelSettings("", "", "Note", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.noteDialogRef;
    this.noteDialogRef.afterClosed().subscribe(result => {
      debugger;
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;
      let noteref: encounterprogressnotesreference = <encounterprogressnotesreference>ref.componentInstance.data.record;

      if (srcType == IceTypes.SourceType.srcDiagnosis) {
        let diag: diagnosis = <diagnosis>ref.componentInstance.data.parentrecord;
        if (hdrCtrl.id == "RemoveLink") {
          if (Iceutility.yesnomodal("Would you like to unlink this note?\nOk - to unlink this note.\nCancel - to abandon this action.")) {
            let fndNoteRefs = diag.NOTES.filter(x => x.encounter_progress_notes_reference_key != noteref.encounter_progress_notes_reference_key);
            diag.NOTES = fndNoteRefs;
            this.insertUpdateProblem(diag);
          }
          return;
        }
      }

      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && prec != null && noteref != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "encounter_progress_notes_key": {
                  debugger;
                  let keyLink = ctrl.getFormControl().value;
                  if (keyLink == "") {
                    note.src_key = srcKey;
                    note.src_type = IceTypes.SourceType.srcDiagnosis;
                  }
                  else {
                    let fndLink = ctrl.getOptions().filter(o => o.value == keyLink);
                    if (fndLink.length > 0) {
                      note.src_key = fndLink[0].srckey;
                      note.src_type = fndLink[0].srctype;
                    }
                  }
                  break;
                }
                case "plain_text": {
                  note.plain_text = ctrl.getFormControl().value;
                  break;
                }
                case "note_date": {
                  note.note_date = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "note_status_type": {
                  note.note_status_type = ctrl.getFormControl().value;
                  break;
                }
                case "provider_trans_account": {
                  try {
                    let proObj = JSON.parse(ctrl.getFormControl().value);
                    if (proObj != null && proObj.length > 0) {
                      note.provider_trans_account = proObj[0].value;
                    }
                    else {
                      throw "No provider selected or error saving provider.";
                    }
                  }
                  catch (e) {
                    this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, e);
                  }
                  break;
                }
              }
            }
          }

          if (srcType == IceTypes.SourceType.srcEncounterNotes
            && noteref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
            let enc: encounter = <encounter>prec;
            note.src_key = enc.encounter_key;
          }

          this.ptSvc.insertUpdateNote(this.currentPatient, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), note).subscribe(
            data => {
              if (data == null || data.length == 0) {
                // to do reload popup to try again.
                this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Failed to save note.");
                return; 
              }
              let updatednote = data[0];
              this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully saved note.");
              if (srcType == IceTypes.SourceType.srcDiagnosis) {
                let diag: diagnosis = <diagnosis>prec;
                if (noteref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
                  noteref.encounter_progress_notes_key = updatednote.encounter_progress_notes_key;
                  noteref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                  diag.NOTES.push(noteref);
                  if (note.offline_record_status == IceTypes.offlineRecStatus.offlineInsert)
                    this.notes.push(updatednote); // this is not a link
                }
                this.insertUpdateProblem(diag);
              } else {
                let enc: encounter = <encounter>prec;
                if (noteref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
                  noteref.encounter_key = enc.encounter_key;
                  noteref.encounter_progress_notes_key = updatednote.encounter_progress_notes_key;
                  noteref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                  enc.NOTES.push(noteref);
                  if (note.offline_record_status == IceTypes.offlineRecStatus.offlineInsert)
                    this.notes.push(updatednote); // this is not a link
                }
                this.insertUpdateEncounter(enc);
              }
            },
            error => {
              console.log(JSON.stringify(error))
              this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Saving note.");
            }
          );
        }
      }
    });

  }

  ////////////////////////////////////
  // Event handlers
  onsearchICDCtrlQuery(event): void {
    let keyword: string = event["value"];
    if (keyword.length < 3) return;
    this.medCodeSvc.getCodes("ICDCODE", "", "", keyword).subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          debugger;
          let icds: basecode[] = data;
          let icdOpts = icds.map((x) => { return { name: x.code + " - " + x.title, value: x.code } });
          this.searchICDCtrl.setOptions(this.searchICDCtrl.getOptions().concat(icdOpts), false);
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading diagnosis codes.");
      });
  }

  onsearchICDCtrlChange(event) {
    debugger;
  }

  addProblemClick(event): void {
    let diag: diagnosis = new diagnosis();
    diag.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doProblemPopup(diag);
  }

  onProblemClick(event, diag: diagnosis): void {
    this.doProblemPopup(diag);
  }
  onAddObservationClick(event, diag: diagnosis) {
    let observ = new observation();
    this.doObservationPopup(observ, diag);
  }
  onObservatonClick(event, diag: diagnosis): void {
    if (this.diagContainer[event["matListSettings"].tag] == null) return;
    let fndOb = diag.OBSERVS.filter(x => x.observation_key == event["item"].value);
    if (fndOb.length == 0) return;
    this.doObservationPopup(fndOb[0], diag);
  }
  onAddProblemNoteClick(event, diag: diagnosis) {
    let note = new encounterprogressnotesreference();
    this.doNotePopup(note, IceTypes.SourceType.srcDiagnosis, diag.diagnosis_key, diag);
  }
  onProblemNoteClick(event, diag: diagnosis): void {
    if (this.diagContainer[event["matListSettings"].tag] == null) return;
    let fndNoteRef = diag.NOTES.filter(x => x.encounter_progress_notes_key == event["item"].value);
    if (fndNoteRef.length == 0) return;
    this.doNotePopup(fndNoteRef[0], IceTypes.SourceType.srcDiagnosis, diag.diagnosis_key, diag);
  }

  onICDResultClick(event, icdresult: any): void {
    let fndDx = this.problems.filter(dx => dx.diagnosis_key == icdresult.value);
    if (fndDx.length > 0) {
      this.doProblemPopup(fndDx[0]);
    }
    else {
      let dX: diagnosis = new diagnosis();
      dX.icd_code = icdresult.code;
      dX.title = icdresult.name.replace(dX.icd_code + " - ", "");
      this.doProblemPopup(dX);
    }
  }

  addEncounterClick(event): void {
    let enc: encounter = new encounter();
    enc.trans_account = this.appSvc.getCurrentAccount();
    enc.account_type = this.appSvc.getCurrentAccountType();
    enc.patient_trans_account = this.currentPatient;
    enc.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doEncounterPopup(enc);
  }

  onEditEncounterClick(event, enc: encounter): void {
    this.doEncounterPopup(enc);
  }
  onUnassignEncounterClick(event, enc: encounter): void {
    debugger;
    if (Iceutility.yesnomodal("Would you like to un-assign this encounter?")) {
      this.accSvc.unAssignBilltoEncounter(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
        enc.encounter_key, this.currentSuperBill).subscribe(
          updatedEnc => {
            if (updatedEnc == null || updatedEnc.length == 0) return;

            let idx = this.encounters.findIndex(x => x.encounter_key == enc.encounter_key);
            if (idx >= 0)
              this.encounters[idx] = updatedEnc[0];

            idx = this.assignedEncounters.findIndex(x => x.encounter_key == enc.encounter_key);
            if (idx >= 0)
              this.assignedEncounters[idx] = updatedEnc[0];

            this.encounterUpdate.emit(updatedEnc[0]);
          },
          err => {
            console.log(err);
          }
        );
    }
  }

  onAddEncounterNoteClick(event, enc: encounter) {
    let note = new encounterprogressnotesreference();
    this.doNotePopup(note, IceTypes.SourceType.srcEncounterNotes, enc.encounter_key, enc);
  }
  onEncounterNoteClick(event, enc: encounter): void {
    if (this.encContainer[event["matListSettings"].tag] == null) return;
    let fndNoteRef = enc.NOTES.filter(x => x.encounter_progress_notes_key == event["item"].value);
    if (fndNoteRef.length == 0) return;
    this.doNotePopup(fndNoteRef[0], IceTypes.SourceType.srcEncounterNotes, enc.encounter_key, enc);
  }
}
